$(function() {
  var selectCityId;
  var selectPhotocenterId;

  $(document).on('click', '.js-set-pointer-city', function() {
    selectCityId = $(this).attr('data-id');
    selectPhotocenterId = 0;

    $('.js-set-pointer-city').removeClass('is-active');
    $(this).addClass('is-active');

    var $element = $('.js-set-pointer-address');
    $element.children('option').addClass('is-hidden');
    $element.children('option[data-city="' + selectCityId + '"]').removeClass('is-hidden');

    selectPhotocenterId = $element.children('option[data-city="' + selectCityId + '"]').
      attr('value');
    $element.val(selectPhotocenterId);
  });

  $(document).on('change', '.js-set-pointer-address', function() {
    selectPhotocenterId = $(this).val();
    selectCityId = $(this).
      children('option[value="' + selectPhotocenterId + '"]').
      attr('data-city');
  });

  $(document).on('click', '.js-save-pointer', function() {
    selectPhotocenterId = selectPhotocenterId || $('.js-set-pointer-address').val();
    let rememberMe = $('.navbar-pointers input[name=remember]').is(':checked') ? 1 : 0;
    window.Request.post('/cookie/address', {addressId: selectPhotocenterId, rememberMe: rememberMe}, function () {
      location.reload();
    });
  });

  $(document).on('click', '.js-save-default-pointer', function () {
    selectPhotocenterId = $(this).attr('data-id');

    window.Request.post('/cookie/address', {addressId: selectPhotocenterId}, function () {
      location.reload();
    });
  });

  $(document).on('click', '.js-show-pointers', function() {
    var $element = $('.navbar-pointers');
    if ($element.hasClass('is-hidden')) {
        $element.removeClass('is-hidden');
    } else {
        $element.addClass('is-hidden');
    }
  });

  if (window.isFirstUserEntry === 1) {
    $('.navbar-pointers').removeClass('is-hidden');
  }
});